"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.FAILEDTOUPDA = exports.FAILEDTOCREATE = exports.CREATED = exports.CREATING = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/diaryentries/jobs");
const CurrentActionTypes = require("../../actionTypes/diaryentries/current");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.CREATING = 'CREATING';
exports.CREATED = 'CREATED';
exports.FAILEDTOCREATE = 'FAILEDTOCREATE';
exports.FAILEDTOUPDA = 'FAILEDTOUPDATE';
exports.initialState = {
    status: exports.STANDBY,
    jobs: []
};
const statusLens = monocle.Lens.fromProp('status');
const jobsLens = monocle.Lens.fromProp('jobs');
exports.methods = {};
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(jobsLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
exports.methods[CurrentActionTypes.UPDATE_ENTRY_SUCCESS] = (state, action) => fp.function.compose(jobsLens.set(action.payload.jobs || []), statusLens.set(exports.FETCHED))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
exports.methods[ActionTypes.CREATE_JOBS_REQUEST] = (state, action) => statusLens.set(exports.CREATING)(state);
exports.methods[ActionTypes.CREATE_JOBS_SUCCESS] = (state, action) => fp.function.compose(jobsLens.set(action.payload), statusLens.set(exports.FAILEDTOCREATE))(state);
exports.methods[ActionTypes.CREATE_JOBS_FAILED] = (state, action) => statusLens.set(exports.FAILEDTOCREATE)(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.ADD_JOB] = (state, action) => jobsLens.modify((jobs) => [...jobs, action.payload])(state);
exports.methods[ActionTypes.UPDATE_JOB] = (state, action) => jobsLens.modify((jobs) => {
    const updateIdx = jobs.findIndex((i) => i.id === action.payload.jobId);
    if (updateIdx === -1) {
        statusLens.set('FAILEDTOUPDATE');
        return [...jobs];
    }
    const updatedJobs = [
        ...jobs.slice(0, updateIdx),
        action.payload.job,
        ...jobs.slice(updateIdx + 1)
    ];
    return updatedJobs;
})(state);
//# sourceMappingURL=jobs.js.map